/* Header dropdowns open on hover (mouse only). Click keeps working; touch stays tap-to-open. */
(function () {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  var CLOSE_DELAY = 180;
  document.querySelectorAll('.header__inline-menu details').forEach(function (details) {
    var summary = details.querySelector('summary');
    var timer = null;
    function expanded(state) {
      if (summary) summary.setAttribute('aria-expanded', state ? 'true' : 'false');
    }
    details.addEventListener('mouseenter', function () {
      clearTimeout(timer);
      if (!details.open) {
        details.open = true;
        details.dataset.hoverOpen = '1';
        expanded(true);
      }
    });
    details.addEventListener('mouseleave', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        if (details.dataset.hoverOpen) {
          details.open = false;
          delete details.dataset.hoverOpen;
          expanded(false);
        }
      }, CLOSE_DELAY);
    });
    if (summary) {
      summary.addEventListener('click', function (event) {
        // A click on a label that hover already opened must not fold the menu away again
        if (details.open && details.dataset.hoverOpen) {
          event.preventDefault();
          setTimeout(function () { expanded(true); }, 0);
        }
      });
    }
  });
})();
